import dayjs from "dayjs"; 
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import { motion } from "framer-motion";
import Popover from "@mui/material/Popover";
import IRMenu from "./IRMenu";
import KeyManagerialPersonsModal from "./KeyManagerialPersonsModal";
import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css";
import investmentRegisterCss from "../../../myfin_v2/css/investmentRegister.module.css";
import { getKeyInvestmentPersons, getLinkedCompanies, deleteKeyManagerialPerson } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as PlusIcon } from "../../../myfin_v2/assets/icons/plus.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";
import { ReactComponent as MenuDotsIcon } from "../../../myfin_v2/assets/icons/menu_dot.svg";
import { ReactComponent as EditIcon } from "../../../myfin_v2/assets/icons/edit.svg";
import { ReactComponent as DownGreyIcon } from "../../../myfin_v2/assets/icons/down_grey.svg";
import { ReactComponent as SearchIcon } from "../../../myfin_v2/assets/icons/searchPri.svg";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";
import { ReactComponent as CloseIcon } from "../../assets/icons/close_grey.svg";


const KeyManagerialPersons = () => {

    const { irId } = useParams();
    const history = useHistory();

    const [anchorEl, setAnchorEl] = useState(null);
    const [openPopoverId, setOpenPopoverId] = useState(null);
    const [selectedData, setSelectedData] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [keyPersons, setKeyPersons] = useState([]);
    const [editableRows, setEditableRows] = useState([]);
    const [showHeaderSearch, setShowHeaderSearch] = useState(false);
    const [headerSearchValue, setHeaderSearchValue] = useState("");
    const [showSearch, setShowSearch] = useState(false);
    const [companySearch, setCompanySearch] = useState("");
    const [selectedCompany, setSelectedCompany] = useState(null);

    // ── Replaced static companyList with API-driven state ─────────────────────
    const [companyList, setCompanyList] = useState([]);

    // ── Fetch linked companies from API ───────────────────────────────────────
    useEffect(() => {
        if (!irId) return;
        getLinkedCompanies(irId)
            .then((res) => {
                // API: { success: true, companies: [{ _id, company_name, company_code }] }
                const companies = res.data?.companies || [];
                setCompanyList(companies);
            })
            .catch((err) => {
                console.error("Failed to fetch linked companies:", err);
            });
    }, [irId]);

    useEffect(() => {

    }, [])

    const filteredCompanies = companyList.filter((c) =>
        c.company_name.toLowerCase().includes(companySearch.toLowerCase())
    );

    const open = Boolean(anchorEl);

    const handleAdd = () => {
        setSelectedData(null);
        setModalType("add");
        setModalOpen(true);
    };

    const handleMenuClick = (event, id) => {
        setAnchorEl(event.currentTarget);
        setOpenPopoverId(id);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopoverId(null);
    };

    const handleEdit = (item) => {
        setSelectedData(item);
        setModalType("edit");
        setModalOpen(true);
        handleClose();
    };

  const handleDelete = async (id) => {

  const willDelete = await swal({
    title: "Are you sure?",
    text: "This record will be permanently deleted!",
    buttons: ["Cancel", "Yes, delete it"],
    dangerMode: true,
  });

  if (!willDelete) return;

  try {
    const response = await deleteKeyManagerialPerson(irId, id);

    if (response.status === 200) {

      swal({
        title: "Deleted!",
        text: "Record deleted successfully.",
        icon: "success",
        timer: 1500,
        buttons: false,
      });

      fetchKeyManagerialPersons();
    }

  } catch (error) {
    console.log("Delete Error:", error);

    swal({
      title: "Delete failed",
      text: "Something went wrong.",
      icon: "error",
    });
  }

  handleClose();
};

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedData(null);
        setModalType(null);
    };

    const handleRowChange = (id, field, value) => {
        setEditableRows((prev) =>
            prev.map((row) =>
                row._id === id ? { ...row, [field]: value } : row
            )
        );
    };

    const nameOptions = keyPersons.map((p) => p.name);
    const designationOptions = keyPersons.map((p) => p.designation);

    const fetchKeyManagerialPersons = async () => {
        try {
            const res = await getKeyInvestmentPersons(irId, selectedCompany?._id);
            if (res.data.success) {
                const persons = res.data.keyManagerialPersons || [];
                setKeyPersons(persons);
                setEditableRows(persons);
            }
        } catch (error) {
            console.log("Error fetching Key Managerial Persons:", error);
        }
    };

    useEffect(() => {
        const closeSearch = (e) => {
            if (!e.target.closest(`.${investmentRegisterCss.companyPanelHeader}`)) {
                setShowSearch(false);
            }
        };
        document.addEventListener("click", closeSearch);
        return () => document.removeEventListener("click", closeSearch);
    }, []);

    useEffect(() => {
        if (selectedCompany) fetchKeyManagerialPersons();
    }, [selectedCompany?._id]);

    useEffect(() => {
        if (filteredCompanies.length > 0 && !selectedCompany) {
            setSelectedCompany(filteredCompanies[0]);
        }
    }, [filteredCompanies]);

    const displayRows = editableRows.filter((item) => {
        if (!headerSearchValue) return true;
        const search = headerSearchValue.toLowerCase();
        const formattedAppointment = item.dateOfAppointment ? dayjs(item.dateOfAppointment).format("DD-MMM-YYYY").toLowerCase() : "";
        const formattedResignation = item.dateOfResignation ? dayjs(item.dateOfResignation).format("DD-MMM-YYYY").toLowerCase() : "";
        return (
            (item.name && item.name.toLowerCase().includes(search)) ||
            (item.designation && item.designation.toLowerCase().includes(search)) ||
            formattedAppointment.includes(search) ||
            formattedResignation.includes(search)
        );
    });

    return (
        <>
            <div className={`d-flex ${commoncss.pageContent}`}>
                <IRMenu
                    activeTab={"Key Managerial Persons"}
                    registerID={irId}
                />
                <motion.div
                    initial={{ x: 200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    exit={{ x: 200, opacity: 0 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                    className={investmentRegisterCss.irLayout}
                >
                    <div className={investmentRegisterCss.iRHeader}>
                        {showHeaderSearch ? (
                            <div className={investmentRegisterCss.headerSearchBar}>
                                <SearchIcon className={investmentRegisterCss.headerSearchBarIcon} />
                                <input
                                    autoFocus
                                    type="text"
                                    className={investmentRegisterCss.headerSearchInput}
                                    placeholder="Type something..."
                                    value={headerSearchValue}
                                    onChange={(e) => setHeaderSearchValue(e.target.value)}
                                />
                                <CloseIcon
                                    className={investmentRegisterCss.headerSearchClose}
                                    onClick={() => {
                                        setShowHeaderSearch(false);
                                        setHeaderSearchValue("");
                                    }}
                                />
                            </div>
                        ) : (
                            <SearchIcon
                                style={{ cursor: "pointer" }}
                                onClick={() => setShowHeaderSearch(true)}
                            />
                        )}
                        <FilterIcon />
                    </div>

                    <div className={investmentRegisterCss.shareCapitalLayout}>

                        <div className={investmentRegisterCss.companyPanel}>
                            <div className={investmentRegisterCss.companyPanelHeader}>
                                <span className={investmentRegisterCss.companyPanelTitle}>Select Company</span>
                                <span className={investmentRegisterCss.companyPanelSearchIcon}>
                                    <SearchIcon onClick={() => setShowSearch((prev) => !prev)} />
                                </span>
                            </div>

                            {showSearch && (
                                <div className={investmentRegisterCss.companySearchInputWrapper}>
                                    <input
                                        type="text"
                                        className={investmentRegisterCss.companySearchInput}
                                        placeholder="Search company..."
                                        value={companySearch}
                                        onChange={(e) => setCompanySearch(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                            )}

                             <ul className={investmentRegisterCss.companyList}>
                                {filteredCompanies.map((company) => (
                                    <li
                                        key={company._id}
                                        className={`${investmentRegisterCss.companyListItem} ${
                                            selectedCompany?._id === company._id
                                                ? investmentRegisterCss.companyListItemActive
                                                : ""
                                        }`}
                                        onClick={() => setSelectedCompany(company)}
                                        data-tooltip={company.company_name}
                                        title={company.company_name}
                                    >
                              
                                        {company.company_name}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className={investmentRegisterCss.tableLayout}>
                            <div className={investmentRegisterCss.tableConatiner}>
                                <div className={investmentRegisterCss.tableTitle}>
                                    <span>Key Managerial Persons</span>

                                    {!isEditing ? (
                                        <span className="d-flex gap-1">
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<EditIcon />}
                                                class_={investmentRegisterCss.editBtn}
                                                onClick={() => setIsEditing(true)}
                                            />
                                            <Button
                                                btnColor={buttoncss.greyBg}
                                                icon={<PlusPrimaryIcon />}
                                                class_={investmentRegisterCss.addBtnRow}
                                                onClick={handleAdd}
                                            />
                                        </span>
                                    ) : (
                                        <div className={investmentRegisterCss.saveCancelWrap}>
                                            <button
                                                className={investmentRegisterCss.cancelBtn}
                                                onClick={() => {
                                                    setIsEditing(false);
                                                    setEditableRows([...keyPersons]);
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className={investmentRegisterCss.saveBtn}
                                                onClick={() => {
                                                    console.log("Saved Data:", editableRows);
                                                    setIsEditing(false);
                                                }}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <table>
                                    <thead>
                                        <tr>
                                            <th style={{ textAlign: "left", paddingLeft: "20px" }}>Name</th>
                                            <th style={{ textAlign: "left" }}>Designation</th>
                                            <th>Date of appointment</th>
                                            <th>Date of resignation</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {displayRows.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center", padding: "20px", color: "#b3c0bd" }}>No key managerial persons data</td>
                                            </tr>
                                        ) : (
                                            displayRows.map((item) => (
                                                <tr key={item._id}>
                                                <td style={{ textAlign: "left", paddingLeft: "20px" }}>
                                                    {isEditing ? (
                                                        <div className={investmentRegisterCss.dropdownWrapper}>
                                                            <select
                                                                value={item.name}
                                                                onChange={(e) =>
                                                                    handleRowChange(item._id, "name", e.target.value)
                                                                }
                                                                className={investmentRegisterCss.dropdownInput}
                                                            >
                                                                {nameOptions.map((opt) => (
                                                                    <option key={opt} value={opt}>{opt}</option>
                                                                ))}
                                                            </select>
                                                            <span className={investmentRegisterCss.dropdownArrow}>
                                                                <DownGreyIcon />
                                                            </span>
                                                        </div>
                                                    ) : (item.name)}
                                                </td>

                                                <td style={{ textAlign: "left" }}>
                                                    {isEditing ? (
                                                        <div className={investmentRegisterCss.dropdownWrapper}>
                                                            <select
                                                                value={item.designation}
                                                                onChange={(e) =>
                                                                    handleRowChange(item._id, "designation", e.target.value)
                                                                }
                                                                className={investmentRegisterCss.dropdownInput}
                                                            >
                                                                {designationOptions.map((opt) => (
                                                                    <option key={opt} value={opt}>{opt}</option>
                                                                ))}
                                                            </select>
                                                            <span className={investmentRegisterCss.dropdownArrow}>
                                                                <DownGreyIcon />
                                                            </span>
                                                        </div>
                                                    ) : (item.designation)}
                                                </td>

                                                <td>
                                                    {isEditing ? (
                                                        <input
                                                            type="date"
                                                            className={investmentRegisterCss.dateInputSmall}
                                                            value={item.dateOfAppointment ? dayjs(item.dateOfAppointment).format("YYYY-MM-DD") : ""}
                                                            onChange={(e) => handleRowChange(item._id, "dateOfAppointment", e.target.value)}
                                                        />
                                                    ) : item.dateOfAppointment ? (
                                                        dayjs(item.dateOfAppointment).format("DD-MMM-YYYY")
                                                    ) : ("-")}
                                                </td>

                                                <td>
                                                    {isEditing ? (
                                                        <input
                                                            type="date"
                                                            className={investmentRegisterCss.dateInputSmall}
                                                            value={item.dateOfResignation ? dayjs(item.dateOfResignation).format("YYYY-MM-DD") : ""}
                                                            onChange={(e) => handleRowChange(item._id, "dateOfResignation", e.target.value)}
                                                        />
                                                    ) : item.dateOfResignation ? (
                                                        dayjs(item.dateOfResignation).format("DD-MMM-YYYY")
                                                    ) : ("-")}
                                                </td>

                                                <td>
                                                    <MenuDotsIcon
                                                        style={{ cursor: "pointer", marginRight: 20 }}
                                                        onClick={(e) => handleMenuClick(e, item._id)}
                                                    />
                                                    <Popover
                                                        open={open && openPopoverId === item._id}
                                                        anchorEl={anchorEl}
                                                        onClose={handleClose}
                                                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                    >
                                                        <div className={investmentRegisterCss.irOptions}>
                                                            <span style={{ borderBottom: "1px solid #EAEEED" }} onClick={() => handleEdit(item)}>Edit</span>
                                                            <span onClick={() => handleDelete(item._id)}>Delete</span>
                                                        </div>
                                                    </Popover>
                                                </td>
                                            </tr>
                                         )))
                                         
                                         }
                                     </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </motion.div>
            </div>

            {modalOpen && (
                <KeyManagerialPersonsModal
                    handleClose={handleModalClose}
                    data={selectedData}
                    type={modalType}
                    investmentID={irId}
                    refreshData={fetchKeyManagerialPersons}
                    companyId={selectedCompany._id}
                />
            )}
        </>
    );
};

export default KeyManagerialPersons;